import countries from "./countries";

/** Deterministic per-country colors using golden-angle hue spread.
 *  Countries added after the initial data set are kept in ADDED_LATER so
 *  their insertion never shifts the index — and color — of existing countries. */
const COUNTRY_COLORS = {};

const ADDED_LATER = new Set(["AD", "BH", "LI", "MC", "MT", "SM", "SG", "VA", "XK", "MV"]);

const original = [...countries].filter((c) => !ADDED_LATER.has(c.code)).sort((a, b) => a.code.localeCompare(b.code));
const added   = [...countries].filter((c) =>  ADDED_LATER.has(c.code)).sort((a, b) => a.code.localeCompare(b.code));

[...original, ...added].forEach((c, i) => {
  const h = (i * 137.508) % 360;
  const sat = 40 + (i % 4) * 10;
  const lit = 45 + (i % 5) * 7;
  COUNTRY_COLORS[c.code] = `hsl(${Math.round(h)},${sat}%,${lit}%)`;
});
COUNTRY_COLORS.AQ = "hsl(200,15%,78%)";
COUNTRY_COLORS.GL = "hsl(200,20%,82%)";

export default COUNTRY_COLORS;
